import React from 'react'
import config from 'config'

// Functions
import formatNumber from 'functions/format-number'

// Static Data
import CurrencyTypes from 'data/currency-types'

const useCurrencyInfo = (currencySymbol, currencyCode, currencyID) => {
	let currencyData = CurrencyTypes.find((type) => {
		return (
			(currencySymbol && currencySymbol === type.symbol) ||
			(currencyCode && currencyCode === type.code) ||
			(currencyID && currencyID === type.value)
		);
	})

	return currencyData ? currencyData : {
		label: currencyCode + ' ('+currencySymbol+')',
		code: currencyCode,
		symbol: currencySymbol,
	};
}

const Pricebox = (props) => {
	const [priceBase, priceDecimal] = (props.format ? formatNumber(props.price) : props.price).split(',');

	const currency = useCurrencyInfo(props.currency, props.currencyCode, props.currencyID);

	const currencyVal = currency ? currency[config.currencyDisplayMode] : '';

	return (
		<span className={'pricebox' + (!props.monochrome ? ' colored' : '') + (props.warning ? ' warning' : '') + (props.conversion ? ' conversion' : '') + (props.big ? ' big' : '') + (props.className ? (' ' + props.className) : '')}>
			{!props.showCode && config.currencyDisplayPosition === 'start' && <span className="pricebox-currency">{currencyVal}</span>}<span className="pricebox-amount">{priceBase},<sub className="pricebox-decimal">{priceDecimal}</sub>{props.showCode ? <span className="pricebox-code">{currency.code}</span> : <>{config.currencyDisplayPosition !== 'start' && <span className="pricebox-currency after">{currencyVal}</span>}</>}{props.afterText && <span className="pricebox-aftertext">{props.afterText}</span>}</span>
		</span>
	)
};

Pricebox.defaultProps = {
	currency: '₺',
	currencyCode: false,
	currencyID: false,
	showCode: false,
	price: 0,
	monochrome: false,
	warning: false,
	big: false,
	afterText: false,
	format: true,
}

export default Pricebox